import { render } from "./SidebarCategory.vue?vue&type=template&id=74da6193&ts=true"
import script from "./SidebarCategory.vue?vue&type=script&lang=ts"
export * from "./SidebarCategory.vue?vue&type=script&lang=ts"

import "./SidebarCategory.vue?vue&type=style&index=0&id=74da6193&lang=scss"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__